import { useEffect, useState } from "react";

const getNestedValue = (obj, key) => {
  return key.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : ""), obj);
};

export const useSortableTable = (data) => {
  const [tableData, setTableData] = useState(data || []);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");

  // Sync table data when Redux `data` updates
  useEffect(() => {
    setTableData(data || []);
  }, [data]);

  const handleSorting = (field, order) => {
    setSortField(field);
    setSortOrder(order);

    if (!field) return;

    const sorted = [...(data || [])].sort((a, b) => {
      const aVal = getNestedValue(a, field);
      const bVal = getNestedValue(b, field);

      if (aVal === null || aVal === "") return 1;
      if (bVal === null || bVal === "") return -1;

      return (
        aVal.toString().localeCompare(bVal.toString(), "en", { numeric: true }) *
        (order === "asc" ? 1 : -1)
      );
    });

    setTableData(sorted);
  };

  return [tableData, handleSorting];
};
